import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './representative-truck-implement.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const RepresentativeTruckImplementDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const representativeTruckImplementEntity = useAppSelector(state => state.representativeTruckImplement.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="representativeTruckImplementDetailsHeading">
          <Translate contentKey="fleetSenseApp.representativeTruckImplement.detail.title">RepresentativeTruckImplement</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{representativeTruckImplementEntity.id}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.representativeTruckImplement.company">Company</Translate>
          </dt>
          <dd>{representativeTruckImplementEntity.company ? representativeTruckImplementEntity.company.id : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.representativeTruckImplement.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{representativeTruckImplementEntity.truckImplement ? representativeTruckImplementEntity.truckImplement.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/representative-truck-implement" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/representative-truck-implement/${representativeTruckImplementEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RepresentativeTruckImplementDetail;
